export const TECHNOLOGY_SUPPORT_EMAIL = 'technologysupport@medicallawservices.co.uk';
